var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "header" }, [_vm._v("Add Feedback")]),
    _vm._v(" "),
    _c(
      "form",
      {
        ref: "form",
        staticClass: "form response-form",
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.onSubmit.apply(null, arguments)
          },
        },
      },
      [
        _c("div", { staticClass: "reply" }, [
          _c("div", { staticClass: "reply__buttons" }, [
            _c("img", {
              staticClass: "avatar avatar--small",
              attrs: { ":src": `/images/avatar/${_vm.user.id}`, alt: "" },
            }),
          ]),
          _vm._v(" "),
          _c("fieldset", { staticClass: "reply__fields" }, [
            _c("div", { staticClass: "form__group" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.feedback,
                    expression: "formData.feedback",
                  },
                ],
                staticClass: "form__control",
                attrs: { placeholder: "Enter your response here..." },
                domProps: { value: _vm.formData.feedback },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.formData, "feedback", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _vm._m(0),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form__group" }, [
      _c("button", { staticClass: "btn btn--primary" }, [_vm._v("Save")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }